import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';

import { AppComponent, ImagePreLoadDirective } from './app.component';
import { RouterModule } from '@angular/router';
import { HandshakeService } from './app.service';
import { BrandingService } from './branding.service';
import { ConfigService } from './config.service';

@NgModule({ declarations: [
  AppComponent,
  ImagePreLoadDirective
],
bootstrap: [AppComponent], imports: [BrowserModule,
  RouterModule.forRoot([])], providers: [
  { provide: APP_BASE_HREF, useValue: '/' },
  HandshakeService,
  BrandingService,
  ConfigService,
  provideHttpClient(withInterceptorsFromDi())
] })
export class AppModule { }
